module.exports = __webpack_public_path__ + "ipetbooking/admin/img/address-book.f06b90df.svg";